import _defineProperty from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Amplify, CookieStorage, defaultStorage } from '@aws-amplify/core';
import { parseAWSExports } from '@aws-amplify/core/internals/utils';
import { cognitoUserPoolsTokenProvider, cognitoCredentialsProvider } from '@aws-amplify/auth/cognito'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var DefaultAmplify = {
  /**
   * Configures Amplify with the {@link resourceConfig} and {@link libraryOptions}.
   *
   * @param resourceConfig The {@link ResourcesConfig} object that is typically imported from the
   * `amplifyconfiguration.json` file. It can also be an object literal created inline when calling `Amplify.configure`.
   * @param libraryOptions The {@link LibraryOptions} additional options for the library.
   *
   * @example
   * import config from './amplifyconfiguration.json';
   *
   * Amplify.configure(config);
   */
  configure: function configure(resourceConfig, libraryOptions) {
    var resolvedResourceConfig;

    if (Object.keys(resourceConfig).some(function (key) {
      return key.startsWith('aws_');
    })) {
      resolvedResourceConfig = parseAWSExports(resourceConfig);
    } else {
      resolvedResourceConfig = resourceConfig;
    } // If no Auth config is provided, no special handling will be required, configure as is.
    // Otherwise, we can assume an Auth config is provided from here on.


    if (!resolvedResourceConfig.Auth) {
      Amplify.configure(resolvedResourceConfig, libraryOptions);
      return;
    } // If Auth options are provided, always just configure as is.
    // Otherwise, we can assume no Auth libraryOptions were provided from here on.


    if (libraryOptions !== null && libraryOptions !== void 0 && libraryOptions.Auth) {
      Amplify.configure(resolvedResourceConfig, libraryOptions);
      return;
    } // If no Auth libraryOptions were previously configured, then always add default providers.


    if (!Amplify.libraryOptions.Auth) {
      cognitoUserPoolsTokenProvider.setAuthConfig(resolvedResourceConfig.Auth);
      cognitoUserPoolsTokenProvider.setKeyValueStorage( // TODO: allow configure with a public interface
      libraryOptions !== null && libraryOptions !== void 0 && libraryOptions.ssr ? new CookieStorage({
        sameSite: 'lax'
      }) : defaultStorage);
      Amplify.configure(resolvedResourceConfig, _objectSpread(_objectSpread({}, libraryOptions), {}, {
        Auth: {
          tokenProvider: cognitoUserPoolsTokenProvider,
          credentialsProvider: cognitoCredentialsProvider
        }
      }));
      return;
    } // At this point, Auth libraryOptions would have been previously configured and no overriding
    // Auth options were given, so we should preserve the currently configured Auth libraryOptions.


    if (libraryOptions) {
      // If ssr is provided through libraryOptions, we should respect the intentional reconfiguration.
      if (libraryOptions.ssr !== undefined) {
        cognitoUserPoolsTokenProvider.setKeyValueStorage( // TODO: allow configure with a public interface
        libraryOptions.ssr ? new CookieStorage({
          sameSite: 'lax'
        }) : defaultStorage);
      }

      Amplify.configure(resolvedResourceConfig, _objectSpread({
        Auth: Amplify.libraryOptions.Auth
      }, libraryOptions));
      return;
    } // Finally, if there were no libraryOptions given at all, we should simply not touch the currently
    // configured libraryOptions.


    Amplify.configure(resolvedResourceConfig);
  },

  /**
   * Returns the {@link ResourcesConfig} object passed in as the `resourceConfig` parameter when calling
   * `Amplify.configure`.
   *
   * @returns An {@link ResourcesConfig} object.
   */
  getConfig: function getConfig() {
    return Amplify.getConfig();
  }
};
export { DefaultAmplify };